import React from 'react';
import { rhythm } from '../utils/typography';

export default () => (
  <footer style={{ marginTop: rhythm(2.5) }}>
    <small>
      <center>
        <p>
          Powered by <a href="https://gatsbyjs.org">Gatsby.</a>
        </p>
        <p>© 2018-2021 Max Desiatov</p>
      </center>
    </small>
  </footer>
);



// WEBPACK FOOTER //
// ./src/components/Footer.js